import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { MaterialComponentsModule } from './material/material-components.module';
import { SignInComponent } from './layout/components/sign-in/sign-in.component';
import { SwitchOrganizationPopupComponent } from './layout/components/profile/switch-organization-popup/switch-organization-popup.component';
import { BnaServicesAuthClientModule } from 'bna-angular-auth-client';
import { LogLevel } from 'angular-auth-oidc-client';
import {DatePipe} from '@angular/common';
import { environment } from '../environments/environment';
import { SignOutComponent } from './layout/components/sign-out/sign-out.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    SignOutComponent,
    SwitchOrganizationPopupComponent,
    SwitchOrganizationPopupComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    LayoutModule,
    MaterialComponentsModule,
    MatDialogModule,
    ReactiveFormsModule,
    BnaServicesAuthClientModule.forRoot({
      iframe_integration: environment.iframe_integration,
      authConfig: {
        config: {
          configId: environment.idp.clientId,
          authority: environment.idp.authority,
          redirectUrl: window.location.origin + '/sign-in',
          postLogoutRedirectUri: window.location.origin + '/sign-out',
          clientId: environment.idp.clientId,
          scope: environment.idp.scope,
          responseType: 'code',
          silentRenew: true,
          silentRenewTimeoutInSeconds: 60 * 1440, // 1 day
          useRefreshToken: true,
          enableIdTokenExpiredValidationInRenew: false,
          renewTimeBeforeTokenExpiresInSeconds: 150,
          tokenRefreshInSeconds: 30,
          logLevel: environment.production ? LogLevel.Error : LogLevel.Debug,
          autoUserInfo: true,
          secureRoutes: [environment.baseUrl],
        },
      },
    }),
  ],
  providers: [DatePipe, { provide: MAT_DATE_LOCALE, useValue: 'en-au' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
